/**
 * What Symbols says when a search finds nothing — SPEC-symbols-equations §7.
 * It states the catalog's size, doesn't apologise and doesn't offer a web
 * search. For a single pasted character (paste-to-fix's "Look up ℵ") it names
 * the codepoint and drops "paste the character instead": the author just did,
 * and that character is the one that won't compile.
 */
export interface SymbolsEmptyState {
  headline: string;
  catalogLine: string;
  codepoint: string | null;
  routes: string[];
}

export function symbolsEmptyState(query: string, catalogSize: number): SymbolsEmptyState {
  const q = query.trim();
  const chars = [...q];
  const single = chars.length === 1 && chars[0].codePointAt(0)! > 0x7f ? chars[0] : null;
  const typeIt = "Type the command yourself — Lilia passes unknown commands through; you only lose the package check.";
  return {
    headline: `Not in the ${catalogSize} symbols we have yet.`,
    catalogLine: "The catalog is a starting set, not a reference. It grows.",
    codepoint: single
      ? `U+${single.codePointAt(0)!.toString(16).toUpperCase().padStart(4, "0")} · ${single}`
      : null,
    routes: single ? [typeIt] : ["Paste the character instead.", typeIt],
  };
}
